export const MANDATORY_COLUMNS_MSG_KEY = {
  'User_DISPLAYNAME.ATTESTATIONS': 'User_DISPLAYNAME.CERTIFICATIONS',
  'Account_DISPLAYNAME.ATTESTATIONS': 'Account_DISPLAYNAME.CERTIFICATIONS',
  'Role_DISPLAYNAME.ATTESTATIONS': 'Role_DISPLAYNAME.CERTIFICATIONS',
  'Ent_DISPLAYNAME.ATTESTATIONS': 'Ent_DISPLAYNAME.CERTIFICATIONS',
};
